'use client'

import { Splide, SplideSlide } from '@splidejs/react-splide'
import isEmpty from 'lodash/isEmpty'
import { ReactElement } from 'react'

interface HotelRoomModalImageSliderProps {
  sliderElements: {
    image: ReactElement
    caption?: string | null
  }[]
}

export default function HotelRoomModalImageSlider(props: HotelRoomModalImageSliderProps) {
  return (
    <Splide
      options={{
        pagination: true,
        classes: {
          prev: 'splide__arrow--prev bg-white',
          next: 'splide__arrow--next bg-white',
        },
        arrowPath:
          'M31.2538 19.9967L30.1252 21.1252L17.3857 33.8714L16.2571 35L14.0066 32.7429L15.1352 31.6143L26.7528 19.9967L15.1286 8.37907L14 7.2505L16.2571 5L17.3857 6.12857L30.1319 18.8681L31.2605 19.9967H31.2538Z',
      }}
    >
      {props.sliderElements.map((sliderElement, index) => (
        <SplideSlide key={index}>
          <div className="relative">
            {sliderElement.image}
            {!isEmpty(sliderElement.caption) && (
              <p className="absolute bottom-2 left-2 bg-white px-3 py-1 text-xs  text-stone-800">
                {sliderElement.caption}
              </p>
            )}
          </div>
        </SplideSlide>
      ))}
    </Splide>
  )
}
